/* eslint-disable complexity */
import { TERMINE_UPDATE_TERMIN } from '@/domain/termine/hooks/graphql/mutation';
import {
  TerminWiederholung,
  toGraphQLMarkierung,
  wiederholungToGraphQLMap,
} from '@/domain/termine/shared/types';
import { UpdateFormValues } from '@/domain/termine/shared/types/UpdateTermineInput';
import {
  Termine_TerminUpdateInput,
  UpdateTerminMutation,
  UpdateTerminMutationVariables,
} from '@/gql/graphql';
import { useMutation } from '@apollo/client/react';

type UpdateProps = {
  termin: UpdateFormValues;
};

export function useUpdateTermin() {
  const [mutate, { data, loading, error }] = useMutation<
    UpdateTerminMutation,
    UpdateTerminMutationVariables
  >(TERMINE_UPDATE_TERMIN, {
    refetchQueries: [
      'GetTagesDaten',
      'GetTermineKalenderByStandortIdAndZeitraum',
    ],
    awaitRefetchQueries: true,
  });

  const updateTermin = async (props: UpdateProps) => {
    let terminUpdate: Termine_TerminUpdateInput = {
      id: props.termin.id,
      datum: props.termin.datum,
      titel: props.termin.titel,
      beschreibung: props.termin.beschreibung,
      specials: props.termin.specials,
      markierung: toGraphQLMarkierung(props.termin.markierung),
      wiederholung:
        wiederholungToGraphQLMap[
          props.termin.wiederholung ?? TerminWiederholung.OHNE
        ],
      beginn: props.termin.beginn,
      ende: props.termin.ende,
      wiederholungBis: props.termin.wiederholungBis,
      terminImage: props.termin.terminBildInput ?? undefined,
    };

    if (
      props.termin.terminKalenderId &&
      props.termin.terminKalenderId !== 'NO_KALENDER'
    ) {
      terminUpdate = {
        ...terminUpdate,
        terminKalenderId: props.termin.terminKalenderId,
      };
    }
    try {
      const result = await mutate({
        variables: {
          termin: terminUpdate,
        },
      });

      if (result.data?.termine_terminUpdate.error) {
        throw new Error(result?.data.termine_terminUpdate.error.message);
      }
      return result.data?.termine_terminUpdate;
    } catch (error) {
      throw error instanceof Error ? error : new Error(String(error));
    }
  };

  return {
    updateTermin,
    response: data?.termine_terminUpdate,
    loading,
    error,
  };
}
